module.exports = __webpack_public_path__ + "img/cnd_Developer_activity.0be76e60.svg";